import React, { useState, useEffect, forwardRef, useImperativeHandle, useRef } from 'react'
import { Button, Col, Modal, Row, Spinner, Table } from 'react-bootstrap';
import {
    DatatableWrapper,
    Filter,
    Pagination,
    PaginationOptions,
    TableBody,
    TableHeader
} from 'react-bs-datatable';
import SparkApi from "../api/SparkApi";
import moment from 'moment';
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import jwt_decode from "jwt-decode";
import * as constants from '../constants/CONSTANT';
import Image from 'react-bootstrap/Image'
import fileDownload from 'js-file-download';

const loadTrackingRowsWithFiles = async (usertrackings) => {
    const arr = [];
    for (let i = 0; i < usertrackings.length; i++) {
        const obj = usertrackings[i];
        const files = await SparkApi.fetchFiles(obj.id);
        const locationImages = [];

        if (files && files.length > 0) {
            for (let j = 0; j < files.length; j++) {
                const file = files[j];
                if (file.filetype === 'jpg' || file.filetype === 'jpeg' || file.filetype === 'png') {
                    const result = await SparkApi.downloadFiles(file.id);
                    locationImages.push({
                        url: window.URL.createObjectURL(result),
                        fileId: file.id,
                        fileTitle: file.title,
                    });
                }
            }
        }

        // One row per check-in; all images in locationImages array
        arr.push({ ...obj, locationImages });
    }
    return arr;
};

const THUMB_SIZE = 48;
const MAX_VISIBLE_THUMBS = 3;

const downloadLocationFile = async (image) => {
    const result = await SparkApi.downloadFiles(image.fileId);
    if (result) {
        fileDownload(result, image.fileTitle || 'location-image');
    }
};

const thumbStyle = {
    width: THUMB_SIZE,
    height: THUMB_SIZE,
    objectFit: 'cover',
    borderRadius: 4,
    border: '1px solid #dee2e6',
    cursor: 'pointer',
};

const LocationImagesCell = ({ images = [] }) => {
    const [showGallery, setShowGallery] = useState(false);

    if (!images.length) {
        return <span className="text-muted">—</span>;
    }

    const visible = images.slice(0, MAX_VISIBLE_THUMBS);
    const hiddenCount = images.length - MAX_VISIBLE_THUMBS;

    return (
        <>
            <div
                className="d-flex align-items-center gap-1 flex-nowrap"
                style={{ maxHeight: THUMB_SIZE + 4, minWidth: 120 }}
            >
                {visible.map((img, index) => (
                    <img
                        key={`${img.fileId}-${index}`}
                        src={img.url}
                        alt={img.fileTitle || `Location ${index + 1}`}
                        style={thumbStyle}
                        onClick={() => setShowGallery(true)}
                        title="View all images"
                    />
                ))}
                {hiddenCount > 0 && (
                    <button
                        type="button"
                        className="btn btn-sm btn-outline-secondary py-0 px-1"
                        style={{ height: THUMB_SIZE, minWidth: THUMB_SIZE, fontSize: '0.75rem' }}
                        onClick={() => setShowGallery(true)}
                    >
                        +{hiddenCount}
                    </button>
                )}
                <button
                    type="button"
                    className="btn btn-link btn-sm p-0 text-nowrap"
                    style={{ fontSize: '0.75rem' }}
                    onClick={() => setShowGallery(true)}
                >
                    View ({images.length})
                </button>
            </div>

            <Modal show={showGallery} onHide={() => setShowGallery(false)} size="lg" centered scrollable>
                <Modal.Header closeButton>
                    <Modal.Title>Location Images ({images.length})</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row className="g-3">
                        {images.map((img, index) => (
                            <Col xs={6} md={4} key={`${img.fileId}-${index}`}>
                                <div className="text-center border rounded p-2 h-100">
                                    <img
                                        src={img.url}
                                        alt={img.fileTitle || `Image ${index + 1}`}
                                        style={{
                                            width: '100%',
                                            maxHeight: 180,
                                            objectFit: 'contain',
                                        }}
                                    />
                                    <Button
                                        size="sm"
                                        variant="outline-primary"
                                        className="mt-2"
                                        onClick={() => downloadLocationFile(img)}
                                    >
                                        Download
                                    </Button>
                                </div>
                            </Col>
                        ))}
                    </Row>
                </Modal.Body>
            </Modal>
        </>
    );
};

const RelatedLocationHistory = (props) => {
    //console.log('fedfsdfs')
    const [modalShow, setModalShow] = React.useState(false);
    const [usertracking, setUsertracking] = React.useState('');
    const [imagebody, setimagebody] = useState([]);
    const [body, setBody] = useState([]);
    // New Change : added state for spinner logic
    const [showSpinner, setShowSpinner] = useState(true);

    useEffect(() => {

        alllocationhistoryaccess()


    }, []);

    const submitUsertrackings = () => {
        setModalShow(false);
        alllocationhistoryaccess();
    }

    const editUserTracking = (row) => {
        setModalShow(true)
        setUsertracking(row.row);
    }

    const alllocationhistoryaccess = async () => {
        try {
            let usertrackings = await SparkApi.fetchUsertrackingsWithstaffId(props.parent.id);

            if (usertrackings && usertrackings.length > 0) {
                setBody(await loadTrackingRowsWithFiles(usertrackings));
            } else {
                setBody([]);
            }
            setShowSpinner(false);
        } catch (error) {
            console.error('Error fetching data:', error);
            setBody([]);
        }
    };

    const fileSize = (bytes) => {
        var exp = (bytes / 1024) / 1024;
        return exp.toFixed(2) + " MB";
    }

    const renderPreview = (body) => {
        return <Image src={body} thumbnail width="200px" />;

    };


    const header = [
        {
            title: 'Login Time', prop: 'logindatetime', cell: (row) => (moment(row.logindatetime).format('DD-MM-YYYY hh:mm A'))
        },
        {
            title: 'Logout Time',
            prop: 'logoutdatetime',
            cell: (row) => (row.logoutdatetime ? moment(row.logoutdatetime).format('DD-MM-YYYY hh:mm A ') : '')
        },
        { title: 'Location', prop: 'location' },
        // { title: 'Attendance Type', prop: 'attandancetype' },
        { title: 'Remarks', prop: 'remarks' },
        {
            title: 'Location Image', prop: 'locationImages', cell: (row) => <LocationImagesCell images={row.locationImages} />
        },
    ];


    return (
        <>
            {/* New Change : here we add the spinner when data is load */}
            {showSpinner ?
                <div className="d-flex justify-content-center align-items-center" >
                    <Spinner animation="border" variant="secondary" size="lg" />
                </div>
                :
                body &&
                <DatatableWrapper body={body} headers={header} paginationOptionsProps={{
                    initialState: {
                        rowsPerPage: 5
                    }
                }}>
                    <Row className="mb-4">
                        <Col
                            xs={12}
                            sm={6}
                            lg={4}
                            className="d-flex flex-col justify-content-start align-items-start"
                        >
                        </Col>
                        <Col
                            xs={12}
                            sm={6}
                            lg={4}
                            className="d-flex flex-col justify-content-start align-items-start"
                        >
                        </Col>
                        <Col
                            xs={12}
                            sm={6}
                            lg={4}
                            className="d-flex flex-col justify-content-end align-items-end"
                        >
                        </Col>
                    </Row>
                    <Table striped className="related-list-table" responsive="sm">
                        <TableHeader />
                        <TableBody />
                    </Table>
                    <Pagination />
                </DatatableWrapper>
            }

        </>
    )
};

export default RelatedLocationHistory;


export const RelatedCheckInHistory = (props) => {
    //console.log('fedfsdfs')
    const [modalShow, setModalShow] = React.useState(false);
    const [usertracking, setUsertracking] = React.useState('');
    const [imagebody, setimagebody] = useState([]);
    const [body, setBody] = useState([]);

    // New Change : added state for spinner logic
    const [showSpinner, setShowSpinner] = useState(true);
    useEffect(() => {

        alllocationhistoryaccess()


    }, []);

    const submitUsertrackings = () => {
        setModalShow(false);
        alllocationhistoryaccess();
    }

    const editUserTracking = (row) => {
        setModalShow(true)
        setUsertracking(row.row);
    }

    const alllocationhistoryaccess = async () => {
        try {
            let usertrackings = await SparkApi.fetchCheckInWithStaffId(props.parent.id);

            if (usertrackings && usertrackings.length > 0) {
                setBody(await loadTrackingRowsWithFiles(usertrackings));
            } else {
                setBody([]);
            }
            setShowSpinner(false);
        } catch (error) {
            console.error('Error fetching data:', error);
            setBody([]);
        }
    };

    const fileSize = (bytes) => {
        var exp = (bytes / 1024) / 1024;
        return exp.toFixed(2) + " MB";
    }

    const renderPreview = (body) => {
        return <Image src={body} thumbnail width="200px" />;

    };


    const header = [
        {
            title: 'Check In Time', prop: 'logindatetime', cell: (row) => (moment(row.logindatetime).format('DD-MM-YYYY hh:mm A'))
        },
        {
            title: 'Check Out Time',
            prop: 'logoutdatetime',
            cell: (row) => (row.logoutdatetime ? moment(row.logoutdatetime).format('DD-MM-YYYY hh:mm A ') : '')
        },
        { title: 'Location', prop: 'location' },
        // { title: 'Attendance Type', prop: 'attandancetype' },
        // Added New Fields (According To Client Request on 07-Nov-2024)
        { title: 'Client Name', prop: 'client_name' },
        { title: 'Phone', prop: 'phone_no' },
        { title: 'Referral Partner Name', prop: 'referral_partner_name' },
        { title: 'Referral Number', prop: 'referral_number' },
        { title: 'postal_address', prop: 'postal_address' },
        //End Here
        { title: 'Remarks', prop: 'remarks' },
        {
            title: 'Location Image', prop: 'locationImages', cell: (row) => <LocationImagesCell images={row.locationImages} />
        },
    ];


    return (
        <>
            {/* New Change : here we add the spinner when data is load */}
            {showSpinner ?
                <div className="d-flex justify-content-center align-items-center" >
                    <Spinner animation="border" variant="secondary" size="lg" />
                </div>
                :
                body &&
                <DatatableWrapper body={body} headers={header} paginationOptionsProps={{
                    initialState: {
                        rowsPerPage: 5
                    }
                }}>
                    <Row className="mb-4">
                        <Col
                            xs={12}
                            sm={6}
                            lg={4}
                            className="d-flex flex-col justify-content-start align-items-start"
                        >
                        </Col>
                        <Col
                            xs={12}
                            sm={6}
                            lg={4}
                            className="d-flex flex-col justify-content-start align-items-start"
                        >
                        </Col>
                        <Col
                            xs={12}
                            sm={6}
                            lg={4}
                            className="d-flex flex-col justify-content-end align-items-end"
                        >
                        </Col>
                    </Row>
                    <Table striped className="related-list-table" responsive="sm">
                        <TableHeader />
                        <TableBody />
                    </Table>
                    <Pagination />
                </DatatableWrapper>}
        </>
    )
};